module.exports = __webpack_public_path__ + "img/chat-quote.2446694d.svg";